import { PageHeader, Button } from '@flos/react-ui';
import { useRecoilValue } from 'recoil';
import { topConfigContextAtom } from '../../../recoil/atoms/topConfigContextAtom';
import { useHippoText } from '../../../hooks/useHippoText';

const RejectedStatusVariant = ({
    handleBackToMpsActivationPage
}: {
    handleBackToMpsActivationPage: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const topConfigContext = useRecoilValue(topConfigContextAtom);
    const mitTopDKHostURL = topConfigContext?.siteConfig?.scope?.includes('mit.')
        ? ''
        : `//${topConfigContext?.siteConfig?.sisterHost ?? ''}`;
    const handleGoToInsuranceListPage = (): void => {
        window.location.href = `${mitTopDKHostURL}/forsikringer/`;
    };

    return (
        <PageHeader
            title={getHippoText('DSS-MPS-FLOW-AGREEMENT-STATUS-STOPPED-HEADER')}
            subtitle={
                <>
                    {' '}
                    <p className="paragraph--large">
                        {getHippoText('DSS-MPS-FLOW-AGREEMENT-STATUS-STOPPED-SUBHEADER')}
                    </p>
                    <p className="paragraph--small">
                        {getHippoText('DSS-MPS-FLOW-AGREEMENT-STATUS-STOPPED-DESCRIPTION')}
                    </p>
                </>
            }
            imageUrl={`${topConfigContext?.resourceUrl ?? ''}/images/man-sad-phone.svg`}
        >
            <div>
                <Button onClick={handleBackToMpsActivationPage} theme="primary" minWidth="widest">
                    {getHippoText('DSS-MPS-FLOW-AGREEMENT-STATUS-STOPPED-CONTINUE-WITH-MPS-BUTTON')}
                </Button>
                <Button onClick={handleGoToInsuranceListPage} theme="secondary" minWidth="widest">
                    {getHippoText(
                        'DSS-MPS-FLOW-AGREEMENT-STATUS-STOPPED-VIEW-POLICY-DETAIL-BUTTON'
                    )}
                </Button>
            </div>
        </PageHeader>
    );
};

export default RejectedStatusVariant;
